import * as Yup from "yup";

export const LoginSchema = Yup.object({
    phone: Yup.string().required("Enter Mobile / Email"),
    password: Yup.string().required("Enter Password"),
});

export const ForgotPasswordStep1Schema = Yup.object({
    username: Yup.string().trim().required("Enter Mobile / Email"),
});

export const ForgotPasswordResetSchema = Yup.object({
    newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Enter new password"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords do not match")
        .required("Confirm your password"),
});